function regenerateIdempotencyKey(form) {
	let randomUUIDFunction

	// In unsecure context (localhost without https) crypto.randomUUID is not available.
	if(crypto.randomUUID) randomUUIDFunction = () => crypto.randomUUID().toString()
	else randomUUIDFunction = crypto.randomUUID = () => ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))

	$(form).find('.idempotency-key-input').val(randomUUIDFunction);
}

$('form:has(.idempotency-key-input)').on('reset', function() {
	regenerateIdempotencyKey(this);
});